import { setStore, getStore, removeStore } from "@/util/store";
import website from "@/const/website";
const common = {
  state: {
    isCollapse: false,
    isFullScren: false,
    isShade: false,
    screen: -1,
    showTag: getStore({ name: "showTag" }),
    showCollapse: getStore({ name: "showCollapse" }),
    showSearch: getStore({ name: "showSearch" }),
    showMenu: getStore({ name: "showMenu" }),
    website: website,
    isRoot: true
  },
  actions: {},
  mutations: {
    SET_SHADE: (state, active) => {
      state.isShade = active;
    },
    SET_OUTROLE: (state, active) => {
      state.isRoot = active;
    },
    SET_COLLAPSE: state => {
      state.isCollapse = !state.isCollapse;
    },
    SET_FULLSCREN: state => {
      state.isFullScren = !state.isFullScren;
    },
    SET_SHOWCOLLAPSE: (state, active) => {
      state.showCollapse = active;
      setStore({
        name: "showCollapse",
        content: state.showCollapse
      });
    },
    SET_SHOWTAG: (state, active) => {
      state.showTag = active;
      setStore({
        name: "showTag",
        content: state.showTag
      });
    },
    SET_SHOWMENU: (state, active) => {
      state.showMenu = active;
      setStore({
        name: "showMenu",
        content: state.showMenu
      });
    },
    SET_SHOWFULLSCREN: (state, active) => {
      state.showFullScren = active;
      setStore({
        name: "showFullScren",
        content: state.showFullScren
      });
    },
    SET_SHOWDEBUG: (state, active) => {
      state.showDebug = active;
      setStore({
        name: "showDebug",
        content: state.showDebug
      });
    },
    SET_SCREEN: (state, screen) => {
      state.screen = screen;
    },
    SET_LOCK_PASSWD: (state, lockPasswd) => {
      state.lockPasswd = lockPasswd;
      setStore({
        name: "lockPasswd",
        content: state.lockPasswd,
        type: "session"
      });
    },
    CLEAR_LOCK: state => {
      state.isLock = false;
      state.lockPasswd = "";
      removeStore({
        name: "lockPasswd"
      });
      removeStore({
        name: "isLock"
      });
    }
  }
};
export default common;
